import React, { FC } from 'react';
import TraceabilityGraph from '@v2/pages/common/components/TraceabilityGraph';
import { useManageNCFileTraceabilityContent } from './hooks/useManageNCFileTraceabilityContent';

export interface NCFileTraceabilityContentProps {
  // The single NC file the graph is anchored on, resolved by the host perspective wrapper.
  ncFileId: number | null;
  // True while the host perspective is still loading and hasn't settled the anchor id yet.
  resolving: boolean;
}

const NCFileTraceabilityContent: FC<NCFileTraceabilityContentProps> = ({ ncFileId, resolving }) => {
  const {
    ncFile,
    ncFileLoaded,
    jobs,
    jobsLoaded,
    batches,
    batchesLoading,
    batchesTotalCount,
    documentCount,
    documentsLoading,
    openPart,
    openProductionOrder,
    openJob,
    openBatch,
    openNcFileSubScreen,
  } = useManageNCFileTraceabilityContent({ ncFileId, resolving });

  return (
    <TraceabilityGraph
      ncFile={ncFile}
      ncFileLoaded={ncFileLoaded}
      jobs={jobs}
      jobsLoaded={jobsLoaded}
      batches={batches}
      batchesLoading={batchesLoading}
      batchesTotalCount={batchesTotalCount}
      documentCount={documentCount}
      documentsLoading={documentsLoading}
      onOpenPart={openPart}
      onOpenProductionOrder={openProductionOrder}
      onOpenJob={openJob}
      onOpenBatch={openBatch}
      onOpenNcFileSubScreen={openNcFileSubScreen}
    />
  );
};

export { NCFileTraceabilityContent };
